// extracted by mini-css-extract-plugin
module.exports = {"loader":"RenderOnClient_loader__j3xg2","spin":"RenderOnClient_spin__pBhZu"};